export class PositionTimer {
  private timeoutId?: NodeJS.Timeout

  // eslint-disable-next-line no-useless-constructor
  constructor(private callback: () => void) {}

  start() {
    this.timeoutId = setTimeout(() => {
      try {
        this.callback()
      } catch (error) {
        console.error('PositionTimer error:', error)
      }
    }, 1000)
  }

  stop() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = undefined
    }
  }

  reset() {
    this.stop()
    this.start()
  }
}
